import { render, staticRenderFns } from "./ManageLeaders.vue?vue&type=template&id=9181c334"
import script from "./ManageLeaders.vue?vue&type=script&lang=js"
export * from "./ManageLeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports